import { connect } from 'react-redux';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import VehicleTitle from '../components/VehicleTitle';
import VehicleTitleSidebar from '../components/VehicleTitleSidebar';
import propDefs from '../proptypes';

const isBrowser = typeof document === 'object';
class WidgetContainer extends React.Component {
	render() {
		let rootComponent;

		if (this.props.vehicle) {
			const isDesktop = this.props.deviceType === 'DESKTOP';
			const vehicleTitleSidebar =
				isBrowser && isDesktop ? (
					<Common
						render={({ prefs, labels }) => {
							return (
								<VehicleTitleSidebar
									vehicle={this.props.vehicle}
									deviceType={this.props.deviceType}
									prefs={prefs}
									labels={labels}
								/>
							);
						}}
					/>
				) : null;

			rootComponent = (
				<Common
					render={({ prefs, labels }) => {
						return (
							<React.Fragment>
								<VehicleTitle
									vehicle={this.props.vehicle}
									deviceType={this.props.deviceType}
									prefs={prefs}
									labels={labels}
								/>
								{vehicleTitleSidebar}
							</React.Fragment>
						);
					}}
				/>
			);
		}
		return rootComponent;
	}
}

WidgetContainer.propTypes = {
	vehicle: propDefs.settings.vehicle,
	deviceType: propDefs.settings.deviceType
};

WidgetContainer.defaultProps = {
	vehicle: propDefs.defaults.vehicle,
	deviceType: propDefs.defaults.deviceType
};

const mapStateToProps = state => {
	return {
		vehicle: state.vehicle,
		deviceType: state.requestData.deviceType
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx